export const VennEvents = {
  invitationSent: 'invitation-sent',
  functionalCookiesAccepted: 'functional-cookies-accepted',
  advertisingCookiesAccepted: 'advertising-cookies-accepted',
  transitioned: 'transitionend',
};
